import { forwardRef } from 'react'

import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Dialog } from '@headlessui/react'
import { msg, Trans } from '@lingui/macro'
import { useLingui } from '@lingui/react'
import PanelLayout from 'Root/App/Dialog/PanelLayout'
import Chip from 'Root/App/Item/Chip'
import Icon from 'Root/App/Item/icon'
import Paragraph from 'Root/App/Paragraph'
import Title from 'Root/App/Title'
import Button from 'Root/Component/Button'

interface RemoveUserAuthorizationAlertProps {
  onClose: () => void
  onConfirm: () => void
  isRemoving: boolean
}

type Ref = HTMLDivElement

const RemoveUserAuthorizationAlert = forwardRef<
  Ref,
  RemoveUserAuthorizationAlertProps
>(function RemoveUserAuthorizationAlert(
  { onClose, onConfirm, isRemoving },
  ref
) {
  const { _ } = useLingui()
  const callToActionButtons = (
    <Button
      variant="danger-filled"
      className="flex-grow"
      onClick={onConfirm}
      loading={isRemoving}
      loadingLabel={_(msg`Rimozione…`)}
    >
      <Trans>Conferma</Trans>
    </Button>
  )

  return (
    <Dialog.Panel
      className="relative flex flex-col pb-6 pt-5 px-6 bg-white rounded-t-3xl shadow-lg2 sm:pb-8 sm:pt-8 sm:px-8 sm:w-auto sm:h-auto sm:rounded-3xl"
      ref={ref}
    >
      <PanelLayout
        title={<Trans>Rimuovi permesso</Trans>}
        cta={callToActionButtons}
        onClose={onClose}
      >
        <Chip
          highlight
          highlightCustomClass="flex flex-col gap-3 bg-white"
          icon={
            <Icon bgColor="bg-brand-accent1">
              <FontAwesomeIcon
                className="text-gray-900 w-5 h-5 text-sm font-black"
                icon={faTriangleExclamation}
              />
            </Icon>
          }
        >
          <span className="flex flex-col items-start gap-1 self-stretch bg-white">
            <Title size="XS">
              <Trans>Sei Sicuro?</Trans>
            </Title>
            <Paragraph className="sm:max-w-sm sm:w-auto">
              <Trans>
                Stai per rimuovere il permesso di accesso per questo elemento.
              </Trans>
            </Paragraph>
          </span>
        </Chip>
      </PanelLayout>
    </Dialog.Panel>
  )
})

export default RemoveUserAuthorizationAlert
